import {AxiosError} from 'axios';
import {POST_RETRIEVE_SCHOOL_CANDIDATE_APPEAL_REGISTRATION} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from '../../api';

export interface SchoolCandidateAppealRegistrationResponse {
  name: string;
  examYear: number;
  uuid: string;
}

export interface SchoolCandidateAppealPaymentDetailsRequest {
  idType: 'NRIC_OR_FIN' | 'PASSPORT';
  uinFinPassport: string;
  schoolUuid: string;
  examYear: number;
  email: string;
}

interface Input {
  onSuccess?: () => void;
  onError?: (e: AxiosError<GenericErrorResponse>) => void;
}

export const usePostRetrieveSchoolCandidateAppealRegistration = ({onSuccess, onError}: Input) => {
  const postRetrieveSchoolCandidateAppealRegistration = async (
      payload: SchoolCandidateAppealPaymentDetailsRequest
  ) => {
    const res = await axiosClient.post<SchoolCandidateAppealRegistrationResponse>(
        POST_RETRIEVE_SCHOOL_CANDIDATE_APPEAL_REGISTRATION,
        payload
    );

    return res.data;
  };

  return useCustomMutation(
      postRetrieveSchoolCandidateAppealRegistration,
      {
        onSuccess,
        onError,
      },
      false,
      false
  );
};
